import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/constants";

export const FloatingWhatsApp = () => (
  <a
    data-testid="floating-whatsapp-button"
    href={waLink("Olá! Vim pelo site da ZARI ENGENHARIA e gostaria de falar com um engenheiro.")}
    target="_blank"
    rel="noreferrer"
    aria-label="Falar no WhatsApp"
    className="fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform duration-300 hover:scale-110"
  >
    <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-25" />
    <MessageCircle size={24} strokeWidth={1.8} className="relative" />
  </a>
);
